import { render, staticRenderFns } from "./reward-picker.vue?vue&type=template&id=0f21d020&scoped=true&"
import script from "./reward-picker.vue?vue&type=script&lang=js&"
export * from "./reward-picker.vue?vue&type=script&lang=js&"
import style0 from "./reward-picker.vue?vue&type=style&index=0&id=0f21d020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f21d020",
  null
  
)

export default component.exports